import { useState } from "react";
import { ChevronDown, ChevronUp, Calendar } from "react-feather";

import Collapse from "../../../../../shared/Collapse/Collapse";

// Collapsible "month group" shell (FE-2268). Every monthly period — the active
// current one and each settled past one — renders with this same header: a
// chevron, the month title, a status badge, and a date-range chip. The body
// content (live cards for the current month, read-only cards for past months) is
// supplied by the caller.

const STATUS_TONE_CLASS = {
  active: "user-manager-game-pass-monthly-status--active",
  completed: "user-manager-game-pass-monthly-status--completed",
  "in-progress": "user-manager-game-pass-monthly-status--in-progress",
  "not-started": "user-manager-game-pass-monthly-status--not-started",
};

const MonthlyGroupSection = ({
  title,
  status,
  dateRange,
  defaultOpen = false,
  open: openProp,
  onOpenChange,
  testId = "monthly-group",
  children,
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
  const isControlled = typeof openProp === "boolean";
  const open = isControlled ? openProp : uncontrolledOpen;
  const toneClass = status ? STATUS_TONE_CLASS[status.tone] ?? "" : "";

  const handleToggle = () => {
    const next = !open;
    if (!isControlled) {
      setUncontrolledOpen(next);
    }
    onOpenChange?.(next);
  };

  return (
    <section
      className="user-manager-game-pass-monthly-group"
      data-testid={testId}
    >
      <button
        type="button"
        className="user-manager-game-pass-monthly-past-header"
        onClick={handleToggle}
        aria-expanded={open}
        data-testid={`${testId}-toggle`}
      >
        <span className="user-manager-game-pass-monthly-past-head-left">
          <span
            className="user-manager-game-pass-monthly-card-chevron"
            aria-hidden="true"
          >
            {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </span>
          <span className="user-manager-game-pass-monthly-past-title">
            {title}
          </span>
        </span>
        <span className="user-manager-game-pass-monthly-past-meta">
          {status && (
            <span
              className={`user-manager-game-pass-monthly-status ${toneClass}`.trim()}
              data-testid={`${testId}-status`}
            >
              {status.label}
            </span>
          )}
          {dateRange && (
            <span
              className="user-manager-game-pass-monthly-past-date"
              data-testid={`${testId}-date`}
            >
              <Calendar size={14} aria-hidden="true" />
              {dateRange}
            </span>
          )}
        </span>
      </button>
      <Collapse open={open} data-testid={`${testId}-collapse`}>
        <div
          className="user-manager-game-pass-monthly-past-body"
          data-testid={`${testId}-body`}
        >
          {children}
        </div>
      </Collapse>
    </section>
  );
};

export default MonthlyGroupSection;
